import { useRouter } from 'vue-router';
import * as utils from '@/utils';

export default () => {
  const router = useRouter();

  const gotoRouter = path => {
    let query = Object.keys(router.currentRoute.value.query).length
      ? router.currentRoute.value.query
      : utils.getUrlParamObj();
    router.push({
      path,
      query: query
    });
  };

  return {
    gotoRouter,
    router,
    hasRoute: router.hasRoute
  };
};
